<template>
  <div v-if="visible" class="common-modal">
    <div class="common-modal-content">
      <div class="common-modal-header">
        <h4>{{ title }}</h4>
        <button class="close-button" @click="close">&times;</button>
      </div>
      <div class="common-modal-body">
        <slot></slot>
      </div>
      <div class="common-modal-footer">
        <slot name="footer">
          <button v-if="showCancelButton" class="btn btn-secondary" @click="close">{{ cancelButtonText }}</button>
          <button v-if="showOkButton" class="btn btn-primary" @click="onOkClick">{{ okButtonText }}</button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'モーダル'
    },
    showOkButton: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    okButtonText: {
      type: String,
      default: 'OK'
    },
    cancelButtonText: {
      type: String,
      default: 'キャンセル'
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onOkClick() {
      this.$emit('ok');
    }
  }
}
</script>

<style scoped>
.common-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.common-modal-content {
  background-color: white;
  border-radius: 5px;
  width: 80%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.common-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #e9ecef;
}

.common-modal-header h4 {
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.common-modal-body {
  padding: 15px;
  overflow-y: auto;
  flex-grow: 1;
}

.common-modal-footer {
  padding: 15px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
